import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { useEvent } from "shared/lib/useEvent"
import { ProductConfigurationFormData } from "shared/types/ProductConfiguration"
import { RJSFForm } from "shared/ui/rjsf-form/RJSFForm"

import { ProductConfiguratorAttributeInformation } from "widgets/product-configurator/ui/attribute-information/ProductConfiguratorAttributeInformation"

import { AddonAccordionContentProps } from "./AddonAccordionContent"

export const AddonAccordionAddonConfiguration = React.memo(
  ({
    addonKey,
    schema,
    formData,
    isDisabled,
    isConfigurable,

    onFormDataChange
  }: AddonAccordionContentProps) => {
    const { t } = useTranslation()

    const schemaWithoutValue = useMemo(
      () => ({
        ...schema,
        properties: {
          ...schema?.properties,
          value: { ...schema?.properties?.value, isHidden: true }
        }
      }),
      [schema]
    )

    const errorMessage = useMemo(
      () => schemaWithoutValue.properties.value.error,
      [schemaWithoutValue]
    )

    const handleChange = useEvent(
      (value: ProductConfigurationFormData, fieldID?: string) =>
        onFormDataChange?.({ [addonKey]: value }, fieldID)
    )

    if (errorMessage) {
      return <span className="text-danger">{errorMessage}</span>
    }

    if (isConfigurable === false) {
      return (
        <span>{t("Product.Configuration.Addon.ConfigurationNotRequired")}</span>
      )
    }

    return (
      <RJSFForm
        id={`product-configuration-${addonKey}`}
        name={`addons.${addonKey}`}
        schema={schemaWithoutValue}
        formData={formData}
        isDisabled={isDisabled}
        isLoading={isConfigurable === undefined}
        className="product-configurator-form"
        onChange={handleChange}
        submitOnChange
        hideSubmitButton
        FieldInformationRenderer={ProductConfiguratorAttributeInformation}
      />
    )
  }
)
